/* Draft recommendation carousel */
(function(){window.SSTheme=window.SSTheme||{};window.SSTheme.initRecommendationCarousel=function(root){if(!root)return function(){};var track=root.querySelector('[data-cart-reco-track],[data-drawer-reco-track]');if(!track)return function(){};var page=0,paused=false;var cards=function(){return Array.prototype.slice.call(track.children)};var render=function(){var n=Math.max(1,Math.ceil(cards().length/(window.matchMedia('(max-width: 560px)').matches?1:2)));page=Math.min(page,n-1);track.style.transform='translate3d('+(-page*track.parentElement.clientWidth)+'px,0,0)';};var move=function(d){var n=Math.max(1,Math.ceil(cards().length/(window.matchMedia('(max-width: 560px)').matches?1:2)));page=(page+d+n)%n;render();};var prev=root.querySelector('[data-cart-reco-prev],[data-drawer-reco-prev]'),next=root.querySelector('[data-cart-reco-next],[data-drawer-reco-next]');if(prev)prev.addEventListener('click',function(){move(-1)});if(next)next.addEventListener('click',function(){move(1)});root.addEventListener('mouseenter',function(){paused=true});root.addEventListener('mouseleave',function(){paused=false});root.addEventListener('focusin',function(){paused=true});root.addEventListener('focusout',function(){paused=false});root.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();move(-1)}else if(e.key==='ArrowRight'){e.preventDefault();move(1)}});render();var timer=window.setInterval(function(){if(!paused)move(1)},5000);return function(){window.clearInterval(timer)}};})();


document.addEventListener('DOMContentLoaded',()=>{if(!Number.isFinite(Number(window.SSFreeShippingThreshold))||Number(window.SSFreeShippingThreshold)<=0)window.SSFreeShippingThreshold=3900;});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.ss-mobile-menu[open]').forEach(menu => {
    if (!menu.contains(event.target) || event.target.closest('nav a')) menu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.ss-mobile-menu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

(() => {
  const header = document.querySelector('.ss-header');
  if (!header || !document.body.classList.contains('template-index')) return;
  const announcement = document.querySelector('.ss-announcement');
  const syncHeader = () => {
    const scrolled = window.scrollY > 12;
    header.classList.toggle('is-scrolled', scrolled);
    announcement?.classList.toggle('is-scrolled', scrolled);
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
})();

(() => {
  document.querySelectorAll('[data-mega-menu-wrap]').forEach(menu => {
    const trigger = menu.querySelector(':scope > .ss-nav-dropdown__link');
    const toggle = menu.querySelector(':scope > [data-mega-menu-toggle]');
    const image = menu.querySelector('[data-mega-image]');
    const links = [...menu.querySelectorAll('[data-menu-image]')];
    if (!trigger || !toggle || !links.length) return;
    const canHover = window.matchMedia('(hover: hover)').matches;
    let suppressNextFocusOpen = false;
    const setOpen = open => {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const setActive = link => {
      links.forEach(item => item.classList.toggle('is-active', item === link));
      if (image?.tagName !== 'IMG' || !link.dataset.menuImage) return;
      image.src = link.dataset.menuImage;
      image.alt = link.dataset.menuAlt || '';
    };
    const closeOthers = () => document.querySelectorAll('[data-mega-menu-wrap].is-open').forEach(item => {
      if (item === menu) return;
      item.classList.remove('is-open');
      item.querySelector(':scope > [data-mega-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    const closeIfOutside = () => {
      if (!menu.matches(':hover') && !menu.matches(':focus-within')) setOpen(false);
    };
    toggle.addEventListener('click', () => {
      const opening = !menu.classList.contains('is-open');
      if (opening) closeOthers();
      setOpen(opening);
    });
    if (canHover) {
      menu.addEventListener('mouseenter', () => { closeOthers(); setOpen(true); });
      menu.addEventListener('mouseleave', () => window.setTimeout(closeIfOutside, 120));
    }
    menu.addEventListener('focusin', () => {
      if (suppressNextFocusOpen) { suppressNextFocusOpen = false; return; }
      closeOthers();
      setOpen(true);
    });
    menu.addEventListener('focusout', () => window.setTimeout(closeIfOutside, 120));
    window.addEventListener('scroll', closeIfOutside, { passive: true });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        if (document.activeElement !== trigger) {
          suppressNextFocusOpen = true;
          trigger.focus();
        }
        return;
      }
      if (!menu.classList.contains('is-open') || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
      event.preventDefault();
      const index = links.indexOf(document.activeElement);
      const next = index < 0
        ? (event.key === 'ArrowDown' ? 0 : links.length - 1)
        : (event.key === 'ArrowDown' ? (index + 1) % links.length : (index - 1 + links.length) % links.length);
      links[next].focus();
    });
    links.forEach((link, index) => {
      link.addEventListener('mouseenter', () => setActive(link));
      link.addEventListener('focus', () => setActive(link));
      if (index === 0) setActive(link);
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-mega-menu-wrap].is-open').forEach(menu => {
      if (menu.contains(event.target) || menu.matches(':hover')) return;
      menu.classList.remove('is-open');
      menu.querySelector(':scope > [data-mega-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });
})();;

(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const body = drawer.querySelector('[data-cart-body]');
  const actions = drawer.querySelector('[data-cart-drawer-actions]');
  const translations = JSON.parse(document.getElementById('SSTranslations')?.textContent || '{}');
  const t = key => key.split('.').reduce((value, part) => value?.[part], translations) || key;
  const recoData = JSON.parse(document.getElementById('CartRecoData')?.textContent || '[]');
  const money = cents => (cents / 100).toLocaleString('lt-LT', { style: 'currency', currency: 'EUR' }).replace(/\u00a0/g, ' ');
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[character]));
  const renderRecoPrice = item => {
    const current = escapeHtml(item.price || '');
    if (item.compare_at_price) return '<span class="ss-reco-price"><del class="ss-compare-price">' + escapeHtml(item.compare_at_price) + '</del> <strong>' + current + '</strong><span class="ss-sale-badge">Išpardavimas</span>' + (item.savings ? '<span class="ss-savings">Sutaupote ' + escapeHtml(item.savings) + '</span>' : '') + '</span>';
    return '<small>' + current + '</small>';
  };
  const syncHeaderCount = cart => document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
  let lastFocused;
  const showError = message => {
    body.innerHTML = '<p role="alert">' + escapeHtml(message || t('cart.error')) + '</p>';
    if (actions) { actions.innerHTML = ''; actions.hidden = true; }
    body.removeAttribute('aria-busy');
  };
  const open = () => {
    if (!drawer.classList.contains('is-open')) lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('ss-drawer-open');
    window.requestAnimationFrame(() => drawer.querySelector('[data-cart-close]')?.focus());
  };
  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('ss-drawer-open');
    if (lastFocused?.isConnected) lastFocused.focus();
    lastFocused = undefined;
  };
  drawer.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', close));
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab' || drawer.getAttribute('aria-hidden') === 'true') return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  const render = cart => {
    syncHeaderCount(cart);
    if (!Array.isArray(cart.items)) throw new Error('cart-items-missing');
    window.dispatchEvent(new CustomEvent('ss:cart-updated', { detail: cart }));
    if (!cart.items.length) { body.innerHTML = '<p>'+t('cart.empty')+'</p><a class="ss-btn" href="/collections/visi-produktai">'+t('cart.continue_shopping')+'</a>'; if (actions) { actions.innerHTML = ''; actions.hidden = true; } return; }
    const inCart=cart.items.map(item=>item.product_id);
    const cartVariantQuantities = new Map();
    cart.items.forEach(item => cartVariantQuantities.set(String(item.variant_id), (cartVariantQuantities.get(String(item.variant_id)) || 0) + Number(item.quantity || 0)));
    const variantCanAdd = variant => variant?.available === true && (variant.tracked !== true || variant.policy !== 'deny' || Number(variant.inventory || 0) > (cartVariantQuantities.get(String(variant.id)) || 0));
    const recos=recoData.filter(item=>!inCart.includes(item.id)).sort((a,b)=>(a.variants?.length || 0) - (b.variants?.length || 0)).slice(0,4);
    const renderReco = item => {
      const title = escapeHtml(item.title);
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '';
      if ((item.variants || []).length > 1) {
        const dialogId = `SSRecoQuickBuy-${item.id}`;
        const firstAvailable = item.variants.find(variantCanAdd);
        const variants = item.variants.map(variant => { const canAdd = variantCanAdd(variant); return `<label class="ss-quick-buy__variant${canAdd ? '' : ' is-unavailable'}"><input type="radio" name="id" value="${escapeHtml(variant.id)}" data-quick-variant data-quick-price="${escapeHtml(variant.price)}" data-variant-inventory="${escapeHtml(variant.inventory || 0)}" data-variant-policy="${escapeHtml(variant.policy || "deny")}" data-variant-tracked="${variant.tracked ? "true" : "false"}"${firstAvailable && variant.id === firstAvailable.id ? ' checked' : ''}${canAdd ? '' : ' disabled'}><span>${escapeHtml(variant.title)}</span><small>${escapeHtml(variant.price)}</small>${canAdd ? '' : '<em>Šiuo metu neprieinama</em>'}</label>`; }).join('');
        return `<article class="ss-cart-reco-card"><div class="ss-cart-reco-card__media">${image}</div><strong>${title}</strong>${renderRecoPrice(item)}<button type="button" class="ss-btn ss-btn--small" data-drawer-quick-open="${dialogId}" aria-haspopup="dialog" aria-controls="${dialogId}">Pasirinkti +</button><dialog class="ss-quick-buy" data-quick-buy id="${dialogId}" aria-labelledby="${dialogId}-title"><div class="ss-quick-buy__panel"><div class="ss-quick-buy__head"><h2 id="${dialogId}-title">${title}</h2><button type="button" class="ss-quick-buy__close ss-btn ss-btn--light" data-quick-buy-close aria-label="Uždaryti">×</button></div><form method="post" action="/cart/add" data-quick-buy-form><fieldset class="ss-quick-buy__variants"><legend>Pasirinkite dydį</legend>${variants}</fieldset><button type="submit" class="ss-btn ss-quick-buy__submit"${firstAvailable ? "" : " disabled"}>Į krepšelį</button><button type="button" class="ss-btn ss-btn--light ss-quick-buy__close-button" data-quick-buy-close>Uždaryti</button></form></div></dialog></article>`;
      }
      if ((item.variants || []).length === 1) {
        const variant = item.variants[0];
        if (!variantCanAdd(variant)) return `<article class="ss-cart-reco-card"><div class="ss-cart-reco-card__media">${image}</div><strong>${title}</strong>${renderRecoPrice(item)}<span class="ss-card-button ss-sold-out">Šiuo metu neprieinama</span></article>`;
        return `<article class="ss-cart-reco-card"><div class="ss-cart-reco-card__media">${image}</div><strong>${title}</strong>${renderRecoPrice(item)}<form method="post" action="/cart/add" data-quick-buy-form><input type="hidden" name="id" value="${escapeHtml(variant.id)}" data-variant-inventory="${escapeHtml(variant.inventory || 0)}" data-variant-policy="${escapeHtml(variant.policy || "deny")}" data-variant-tracked="${variant.tracked ? "true" : "false"}"><button type="submit" class="ss-btn ss-btn--small">Į krepšelį <span aria-hidden="true">+</span></button></form></article>`;
      }
      return `<a class="ss-cart-reco-card" href="${escapeHtml(item.url)}">${image}<span><strong>${title}</strong>${renderRecoPrice(item)}</span></a>`;
    };
    const recoHtml=recos.length?'<section class="ss-cart-drawer__cross" data-drawer-recommendations aria-labelledby="CartDrawerRecommendationsTitle" role="region" aria-roledescription="carousel" tabindex="0"><div class="ss-cart-drawer__cross-head"><h3 id="CartDrawerRecommendationsTitle">Dar gali patikti</h3><div class="ss-cart-drawer__cross-controls"><button type="button" data-drawer-reco-prev aria-controls="CartRecommendationsTrack" aria-label="Ankstesni rekomenduojami produktai">←</button><button type="button" data-drawer-reco-next aria-controls="CartRecommendationsTrack" aria-label="Kiti rekomenduojami produktai">→</button></div></div><div class="ss-cart-drawer__cross-viewport"><div id="CartRecommendationsTrack" class="ss-cart-drawer__cross-track" data-drawer-reco-track>'+recos.map(renderReco).join('')+'</div></div><div class="ss-cart-drawer__cross-status ss-visually-hidden" data-drawer-reco-status aria-live="polite" role="status"></div></section>':'';
    const boxGroups = new Map();
    const standalone = [];
    cart.items.forEach((item, index) => { const boxId = item.properties?._box_id; if (boxId) { if (!boxGroups.has(boxId)) boxGroups.set(boxId, []); boxGroups.get(boxId).push({ item, index }); } else standalone.push({ item, index }); });
    const renderLine = ({item,index}, boxed) => '<div class="ss-cart-drawer__item' + (boxed ? ' ss-cart-drawer__item--boxed' : '') + '"><img src="' + escapeHtml(item.image || '') + '" alt=""><div>' + (boxed ? '<strong>' + escapeHtml(item.product_title) + '</strong>' : '<div class="ss-cart-drawer__title-row"><button type="button" data-drawer-remove="' + index + '" class="ss-drawer-remove ss-drawer-remove--title" aria-label="' + t('cart.remove') + ' ' + escapeHtml(item.product_title) + '">×</button><strong>' + escapeHtml(item.product_title) + '</strong></div>') + (item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '') + (boxed ? '<small class="ss-cart-box-note">Dėžutės sudėtis valdoma konstruktoriuje</small>' : '<div class="ss-drawer-line"><button type="button" data-drawer-qty="' + index + '" data-delta="-1" aria-label="' + t('cart.decrease') + '">−</button><span>' + item.quantity + '</span><button type="button" data-drawer-qty="' + index + '" data-delta="1" aria-label="' + t('cart.increase') + '">+</button></div>') + '<b>' + money(item.final_line_price) + '</b></div></div>';
    let itemHtml = '';
    boxGroups.forEach((group, boxId) => { const first = group[0].item; const size = first.properties?._box_size || ''; const number = first.properties?._box_number || boxId; itemHtml += '<section class="ss-cart-box-group"><div class="ss-cart-box-heading"><h3>Dėžutė #' + escapeHtml(number) + (size ? ' · ' + escapeHtml(size) + ' vietų' : '') + '</h3><div class="ss-cart-box-actions"><a class="ss-btn ss-btn--light ss-cart-box-action ss-cart-box-edit" href="/pages/susikurk-savo-dezute?edit_box=' + encodeURIComponent(boxId) + '">Redaguoti dėžutę</a><button type="button" class="ss-btn ss-btn--light ss-cart-box-action ss-cart-box-remove" data-drawer-box-remove="' + escapeHtml(boxId) + '">Pašalinti dėžutę</button></div></div>' + group.map(entry => renderLine(entry, true)).join('') + '</section>'; });
    itemHtml += standalone.map(entry => renderLine(entry, false)).join('');
    const threshold = Number(window.SSFreeShippingThreshold || 3900);
    const remainingShipping = Math.max(0, threshold - cart.total_price);
    const shippingProgress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    const shippingText = remainingShipping > 0 ? 'Iki nemokamo pristatymo liko ' + money(remainingShipping) : 'Puiku! Jums priklauso nemokamas VENIPAK pristatymas.';
    const shippingHtml = '<div class="ss-free-shipping" aria-live="polite"><p>' + shippingText + '</p><div class="ss-free-shipping__bar"><span style="width:' + shippingProgress + '%"></span></div></div>';
    body.innerHTML = shippingHtml + '<div class="ss-cart-drawer__items">' + itemHtml + '</div>' + recoHtml;
    if (actions) {
      actions.innerHTML = '<div class="ss-cart-drawer__subtotal"><strong>' + t('cart.subtotal') + '</strong><strong>' + money(cart.total_price) + '</strong></div><a class="ss-btn" href="/cart">' + t('cart.view_cart') + ' <span aria-hidden="true">↗</span></a><button type="button" class="ss-text-link" data-drawer-continue>' + t('cart.continue_browsing') + '</button>';
      actions.hidden = false;
    }
    window.SSTheme?.initQuickBuy(body);
    body.querySelectorAll('[data-drawer-qty]').forEach(btn => btn.addEventListener('click', () => update(cart.items[btn.dataset.drawerQty].key, Math.max(0, cart.items[btn.dataset.drawerQty].quantity + Number(btn.dataset.delta)))));
    body.querySelectorAll('[data-drawer-box-remove]').forEach(button => button.addEventListener('click', async () => { const boxId = button.dataset.drawerBoxRemove; const group = cart.items.filter(item => item.properties?._box_id === boxId); button.disabled = true; try { for (const item of group) { const response = await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: item.key, quantity: 0 }) }); if (!response.ok) throw new Error('cart-box-remove-failed'); } await load(); } catch (error) { button.disabled = false; showError('Nepavyko pašalinti dėžutės. Krepšelis nebuvo nukreiptas į apmokėjimą.'); } }));
    body.querySelectorAll('[data-drawer-remove]').forEach(btn => btn.addEventListener('click', () => update(cart.items[btn.dataset.drawerRemove].key, 0)));
    (actions || body).querySelectorAll('[data-drawer-continue]').forEach(button => button.addEventListener('click', close));
    window.SSTheme?.initRecommendationCarousel(body.querySelector("[data-drawer-recommendations]"));
  };
  const load = async () => { const response = await fetch('/cart.js', { headers: {'Accept':'application/json'} }); if (!response.ok) throw new Error('cart-load-failed'); const cart = await response.json(); render(cart); return cart; };
  const update = async (id, quantity) => {
    if (body.dataset.cartBusy === 'true') return;
    body.dataset.cartBusy = 'true';
    body.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id, quantity }) });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error('cart-change-failed');
      render(cart);
    } catch (error) { showError('Nepavyko atnaujinti krepšelio. Patikrinkite prekės likutį ir bandykite dar kartą.'); }
    finally { delete body.dataset.cartBusy; body.removeAttribute('aria-busy'); }
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.dataset.cartSubmitting === 'true') { event.preventDefault(); return; }
    event.preventDefault();
    form.dataset.cartSubmitting = 'true';
    const data = new FormData(form);
    body.innerHTML = '<p>'+t('cart.loading')+'</p>'; open();
    if (actions) { actions.innerHTML = ''; actions.hidden = true; }
    const submitter = form.querySelector('button[type="submit"]');
    if (submitter) { submitter.disabled = true; submitter.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', headers: {'Accept':'application/json'}, body: data }).then(r => { if (!r.ok) throw new Error(); return r.json(); }).then(load).catch(() => { showError('Nepavyko pridėti: patikrinkite prekės likutį ir pasirinkite mažesnį kiekį.'); }).finally(() => { delete form.dataset.cartSubmitting; if (submitter) { submitter.disabled = false; submitter.removeAttribute('aria-busy'); } });
  });
  document.querySelectorAll('[data-cart-open]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(); load().catch(() => showError('Nepavyko įkelti krepšelio. Pabandykite dar kartą.')); }));
})();

(() => {
  document.querySelectorAll('[data-cart-recommendations]').forEach(section => {
    const track = section.querySelector('[data-cart-reco-track]');
    if (!track) return;
    window.SSTheme?.initRecommendationCarousel(section);
  });
})();

(() => {
  document.querySelectorAll('[data-filter-drawer]').forEach(drawer => {
    const trigger = document.querySelector(`[data-filter-open="${drawer.id}"]`);
    const closeButton = drawer.querySelector('.ss-filter-drawer__close');
    if (!trigger) return;
    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ss-filter-open');
      closeButton?.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ss-filter-open');
      trigger.focus();
    };
    trigger.addEventListener('click', open);
    drawer.querySelectorAll('[data-filter-close]').forEach(element => element.addEventListener('click', close));
    drawer.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });
  });
})();

(() => {
  const initQuickBuy = root => {
    (root || document).querySelectorAll('[data-quick-buy]').forEach(dialog => {
      // A product can be rendered in more than one section (for example
      // Featured and Mūsų gamyba). Keep one canonical dialog per product id;
      // duplicate dialogs otherwise all open on a single opener click.
      const canonicalDialog = document.getElementById(dialog.id);
      if (canonicalDialog && canonicalDialog !== dialog) {
        dialog.remove();
        return;
      }
      if (dialog.dataset.quickBuyInitialized === 'true') return;
      dialog.dataset.quickBuyInitialized = 'true';
      const openers = document.querySelectorAll(`[data-quick-buy-open="${dialog.id}"],[data-drawer-quick-open="${dialog.id}"]`);
      const form = dialog.querySelector('[data-quick-buy-form]');
      let lastOpener;
      const close = () => { if (dialog.open) dialog.close(); if (lastOpener?.isConnected) lastOpener.focus(); lastOpener = undefined; };
      if (!openers.length || !form) return;
      openers.forEach(opener => opener.addEventListener('click', () => { lastOpener = opener; if (!dialog.open) dialog.showModal(); }));
      dialog.querySelectorAll('[data-quick-buy-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.querySelectorAll('[data-quick-variant]').forEach(input => input.addEventListener('change', () => {
        const selected = dialog.querySelector('[data-quick-selected-price]');
        if (selected) selected.textContent = input.dataset.quickPrice || '';
      }));
      form.addEventListener('submit', () => window.setTimeout(close, 80));
    });
  };
  window.SSTheme = window.SSTheme || {};
  window.SSTheme.initQuickBuy = initQuickBuy;
  initQuickBuy();
})();

(() => {
  document.querySelectorAll('[data-load-more]').forEach(button => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      const grid = document.getElementById(button.dataset.gridId);
      const wrapper = button.closest('[data-load-more-wrap]');
      if (!grid || !button.dataset.nextUrl) return;
      const defaultLabel = button.dataset.defaultLabel || button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingLabel || button.textContent;
      try {
        const response = await fetch(button.dataset.nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('load-more-failed');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.getElementById(button.dataset.gridId);
        if (!nextGrid) throw new Error('load-more-grid-missing');
        grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        const nextButton = doc.querySelector(`[data-load-more][data-grid-id="${button.dataset.gridId}"]`);
        if (nextButton?.dataset.nextUrl) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
          button.textContent = defaultLabel;
          button.disabled = false;
        } else {
          wrapper?.remove();
        }
        window.SSTheme?.initQuickBuy(grid);
      } catch (error) {
        button.disabled = false;
        button.textContent = button.dataset.errorLabel || defaultLabel;
      } finally {
        if (button.isConnected) button.removeAttribute('aria-busy');
      }
    });
  });
})();

(() => {
  document.querySelectorAll('[data-cart-box-remove]').forEach(button => button.addEventListener('click', async () => {
    if (button.dataset.cartBusy === 'true') return;
    const boxId = button.dataset.cartBoxRemove;
    button.disabled = true;
    button.dataset.cartBusy = 'true';
    try {
      const cartResponse = await fetch('/cart.js', { headers:{'Accept':'application/json'} });
      if (!cartResponse.ok) throw new Error('cart-fetch-failed');
      const cart = await cartResponse.json();
      const group = cart.items.filter(item => item.properties?._box_id === boxId);
      for (const item of group) {
        const response = await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ id:item.key, quantity:0 }) });
        if (!response.ok) throw new Error('cart-box-remove-failed');
      }
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      delete button.dataset.cartBusy;
      const form = button.closest('[data-cart-page-form]');
      let message = form?.querySelector('[data-cart-error]');
      if (!message && form) { message = document.createElement('p'); message.dataset.cartError = 'true'; message.setAttribute('role', 'alert'); form.prepend(message); }
      if (message) message.textContent = 'Nepavyko pašalinti dėžutės. Patikrinkite krepšelį ir bandykite dar kartą.';
    }
  }));
})();

(() => {
  document.querySelectorAll('[data-cart-page-form]').forEach(form => {
    const showError = message => {
      let node = form.querySelector('[data-cart-error]');
      if (!node) { node = document.createElement('p'); node.dataset.cartError = 'true'; node.setAttribute('role', 'alert'); form.prepend(node); }
      node.textContent = message;
    };
    const changeLine = async (lineKey, quantity) => {
      const response = await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ id:lineKey, quantity }) });
      if (!response.ok) { let details = ''; try { details = (await response.json()).description || ''; } catch (error) {} throw new Error(details || 'cart-change-failed'); }
      window.location.reload();
    };
    form.addEventListener('click', event => {
      const button = event.target.closest('[data-cart-quantity],[data-cart-remove]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const line = button.closest('[data-cart-line]');
      const lineKey = line?.dataset.lineKey;
      const input = line?.querySelector('input[name="updates[]"]');
      if (!lineKey || !input) return;
      if (form.dataset.cartBusy === 'true') return;
      const requested = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQuantity || 0));
      const max = input.getAttribute('max') === null ? Infinity : Math.max(0, Number(input.getAttribute('max')) || 0);
      if (requested > max) { showError(`Turime tik ${max} vnt. šios prekės.`); input.value = String(Math.min(Number(input.value || 0), max)); return; }
      const quantity = requested;
      form.dataset.cartBusy = 'true';
      button.disabled = true;
      form.querySelectorAll('[data-cart-quantity],[data-cart-remove]').forEach(control => { control.disabled = true; });
      changeLine(lineKey, quantity).catch(() => { showError('Nepavyko atnaujinti krepšelio. Patikrinkite prekės likutį ir bandykite dar kartą.'); }).finally(() => { delete form.dataset.cartBusy; form.querySelectorAll('[data-cart-quantity],[data-cart-remove]').forEach(control => { control.disabled = false; }); });
    });
    form.addEventListener('change', event => {
      if (!event.target.matches('input[name="updates[]"]')) return;
      const input = event.target;
      let quantity = Math.max(0, Number(input.value) || 0);
      if (input.getAttribute('max') !== null) {
        const max = Math.max(0, Number(input.getAttribute('max')) || 0);
        if (quantity > max) { quantity = max; showError(`Turime tik ${max} vnt. šios prekės.`); }
      }
      input.value = String(quantity);
    });
  });
})();

(() => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    if (!slides.length) return;
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
    let index = 0;
    let timer;
    let manuallyPaused = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { const active = i === index; slide.setAttribute('aria-hidden', active ? 'false' : 'true'); slide.classList.toggle('is-active', active); });
      dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const start = () => { if (slides.length < 2 || reduced || manuallyPaused || timer) return; timer = window.setInterval(() => show(index + 1), 5000); };
    const manual = next => { manuallyPaused = true; stop(); show(next); };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => manual(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => manual(index + 1));
    dots.forEach(dot => dot.addEventListener('click', () => manual(Number(dot.dataset.galleryDot))));
    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) start(); });
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); manual(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); manual(index + 1); }
    });
    let touchStart = 0;
    gallery.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', event => {
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 40) manual(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
    gallery.goToMedia = mediaId => {
      const target = slides.findIndex(slide => String(slide.dataset.mediaId) === String(mediaId));
      if (target >= 0) show(target);
    };
    show(0);
    start();
  });
})();

(() => {
  document.querySelectorAll('.ss-product-info').forEach(info => {
    const options = [...info.querySelectorAll('[data-product-variant]')];
    if (!options.length) return;
    const form = info.querySelector('.ss-product-form');
    const idInput = form?.querySelector('[data-product-variant-id]');
    const price = info.querySelector('[data-product-price]');
    const compare = info.querySelector('[data-product-compare]');
    const submit = form?.querySelector('.ss-product-submit');
    const gallery = info.closest('.ss-product-layout')?.querySelector('[data-product-gallery]');
    const soldOut = submit?.dataset.soldLabel || 'Išparduota';
    const addLabel = submit?.dataset.addLabel || submit?.textContent.replace('↗', '').trim() || 'Į krepšelį';
    const choose = option => {
      options.forEach(item => {
        const selected = item === option;
        item.checked = selected;
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
        item.closest('.ss-product-variant-row')?.classList.toggle('is-selected', selected);
      });
      if (idInput) idInput.value = option.dataset.variantId;
      if (price) price.firstChild.textContent = option.dataset.variantPrice || '';
      if (compare) { compare.textContent = option.dataset.variantCompare || ''; compare.hidden = !option.dataset.variantCompare; }
      const available = option.dataset.variantAvailable === 'true';
      if (submit) { submit.disabled = !available; submit.innerHTML = `${available ? addLabel : soldOut} <span aria-hidden="true">↗</span>`; }
      if (option.dataset.variantImageId) gallery?.goToMedia(option.dataset.variantImageId);
    };
    options.forEach(option => option.addEventListener('change', () => { if (!option.disabled) choose(option); }));
    const initial = options.find(option => option.checked && !option.disabled) || options.find(option => !option.disabled);
    if (initial) choose(initial);
  });
})();

(() => {
  document.querySelectorAll('[data-quantity-stepper]').forEach(stepper => {
    const input = stepper.querySelector('input[name="quantity"]');
    if (!input) return;
    const setQuantity = value => {
      const min = Number(input.min) || 1;
      const maxAttribute = input.getAttribute('max');
      const max = maxAttribute === null ? Infinity : Math.max(min, Number(maxAttribute) || 0);
      input.value = String(Math.min(max, Math.max(min, Number(value) || min)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    stepper.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQuantity(Number(input.value) - 1));
    stepper.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQuantity(Number(input.value) + 1));
  });
})();

(() => {
  if (document.querySelector('[data-cart-drawer]')) return;
  const syncCartCount = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
  };
  const refresh = () => fetch('/cart.js').then(response => response.json()).then(syncCartCount).catch(() => {});
  document.addEventListener('submit', event => {
    if (!event.target.closest('form[action*="/cart/add"]')) return;
    window.setTimeout(refresh, 160);
  });
  window.addEventListener('pageshow', refresh);
})();

(() => {
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-share-copy]');
    if (!button) return;
    const url = button.dataset.shareUrl || window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      const label = button.textContent;
      button.textContent = 'Nukopijuota';
      window.setTimeout(() => { button.textContent = label; }, 1600);
    } catch (error) {}
  });
})();

(() => {
  const infos = [...document.querySelectorAll('.ss-product-info')];
  if (!infos.length) return;
  const cartVariantQuantities = new Map();
  let cartQuantitiesReady = false;
  const syncSale = info => {
    const option = info.querySelector('[data-product-variant]:checked, [data-product-default-variant]');
    if (!option) return;
    const low = info.querySelector('[data-product-low-stock]');
    const inventory = Number(option.dataset.variantInventory || 0);
    const tracked = info.dataset.madeToOrder !== 'true' && option.dataset.variantTracked === 'true' && option.dataset.variantPolicy === 'deny';
    const reserved = cartQuantitiesReady ? Number(cartVariantQuantities.get(String(option.dataset.variantId)) || 0) : 0;
    const remaining = Math.max(0, inventory - reserved);
    const available = option.dataset.variantAvailable === 'true';
    const cartExhausted = tracked && cartQuantitiesReady && available && remaining < 1;
    if (low) { low.hidden = !(tracked && inventory > 0 && inventory <= Number(info.dataset.lowStockThreshold || 3)); low.textContent = low.hidden ? '' : `Liko tik ${inventory} vnt.`; }
    const input = info.querySelector('[data-stock-input]');
    if (input) {
      if (tracked) {
        input.max = String(remaining);
        if (remaining > 0 && Number(input.value || 0) > remaining) input.value = String(remaining);
        input.disabled = !available || cartExhausted;
      } else {
        input.removeAttribute('max');
        input.disabled = false;
      }
    }
    const submit = info.querySelector('.ss-product-submit');
    if (submit && cartQuantitiesReady && tracked) {
      submit.disabled = !available || cartExhausted;
      submit.innerHTML = `${available ? (cartExhausted ? 'Nebeliko likučio' : (submit.dataset.addLabel || 'Į krepšelį')) : (submit.dataset.soldLabel || 'Išparduota')} <span aria-hidden="true">↗</span>`;
    }
    const sale = info.querySelector('[data-product-sale]');
    const savings = info.querySelector('[data-product-savings]');
    const compare = option.dataset.variantCompare || '';
    if (sale) sale.hidden = !compare;
    if (savings) { savings.hidden = !compare; const saved = Math.max(0, Number(option.dataset.variantCompareCents || 0) - Number(option.dataset.variantPriceCents || 0)); savings.textContent = compare && saved ? 'Sutaupote ' + (saved / 100).toLocaleString('lt-LT', { style: 'currency', currency: 'EUR' }) : ''; savings.hidden = !compare || !saved; }
  };
  const applyCart = cart => {
    if (!cart || !Array.isArray(cart.items)) return;
    cartVariantQuantities.clear();
    cart.items.forEach(item => cartVariantQuantities.set(String(item.variant_id), (cartVariantQuantities.get(String(item.variant_id)) || 0) + Number(item.quantity || 0)));
    cartQuantitiesReady = true;
    infos.forEach(syncSale);
  };
  const refreshCartQuantities = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('cart-fetch-failed');
      applyCart(await response.json());
    } catch (error) {}
  };
  infos.forEach(info => {
    info.querySelectorAll('[data-product-variant]').forEach(option => option.addEventListener('change', () => setTimeout(() => syncSale(info), 0)));
    syncSale(info);
  });
  window.addEventListener('ss:cart-updated', event => applyCart(event.detail));
  refreshCartQuantities();
})();

/* Mega-menu image rotation */
(function(){document.querySelectorAll('[data-mega-menu-wrap]').forEach(function(menu){var links=Array.prototype.slice.call(menu.querySelectorAll('[data-menu-image]'));var image=menu.querySelector('[data-mega-image]');if(!image||links.length<2)return;var index=0,timer=null;var show=function(){var link=links[index%links.length];if(link.dataset.menuImage){image.src=link.dataset.menuImage;image.alt=link.dataset.menuAlt||''}index++};var start=function(){if(timer)return;timer=window.setInterval(show,4500)};var stop=function(){if(timer){window.clearInterval(timer);timer=null}};menu.addEventListener('mouseenter',start);menu.addEventListener('mouseleave',stop);menu.addEventListener('focusin',start);menu.addEventListener('focusout',stop);});})();
